<template>
<div class="page page_artDetail page_sellerDetail">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user">
            <div class="top">
                <div class="thumb">
                    <img class="img_2" :src="info.thumb? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" alt />
                </div>
                <!-- <div class="zhuli">助力</div> -->
            </div>
            <div class="info">
                <span class="user_name">{{ info.nickname }}</span>
                <!-- <span class="user_tag" :style="!info.name ? 'margin-left:0': 'margin-left: 0.49rem;'">{{ info.company }}</span> -->
            </div>
            <div class="user_address">{{ info.address }}</div>
        </div>
    </div>
    <!-- 商品 -->
    <van-list v-model="loading_goods" :finished="finished_goods" finished-text="没有更多了" @load="getData" :immediate-check="false">
        <div class="datalist">
            <ul class="list">
                <li class="item" v-for="goods in goodsList" :key="goods.good_id" @click="toGoodsDetail(goods)">
                    <div class="thumb">
                        <!-- <img :src="goods.good_thumb ? goods.good_thumb : $publicData.intangibleDefault" alt=""> -->
                        <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" />
                    </div>
                    <div class="item_xinxi">
                        <div class="title_wrap single">
                            <div class="title_tag">
                                <span class="icon_self" v-if="goods.is_self">自营</span>
                                <span class="icon_new" v-if="goods.is_new">最新</span>
                            </div>
                            <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
                            <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
                            <span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                        </div>
                        <div class="info clearfix">
                            <div class="shop_name f-l slh_s">{{ goods.seller_name }}</div>
                            <div class="source f-r">{{ goods.place }}</div>
                        </div>
                        <div class="info">
                            <span class="f-l price">¥{{ goods.good_price }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </van-list>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            token: null,
            isLoading: false,
            sellerId: this.$route.query.sellerId,
            goodsList: [],
            livesInfo: [],
            imageUrl: this.$publicData.uploadImage,
            pages: {
                page: 1,
                size: 10
            },
            loading_goods: false,
            finished_goods: false,
            loading_live: false,
            finished_live: false,
            shareConfig: null // 分享的相关配置
        };
    },
    created: function () {
        // 根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '供应商详情'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function () {

    },
    methods: {
        getData() {
            var param = {
                token: this.token,
                seller_id: parseInt(this.sellerId),
                page: this.pages.page,
                size: this.pages.size
            }
            console.log(this.loading_goods)
            if (this.isLoading ) {
                return
            }
            this.isLoading = true
            this.$api.tradesman.sellerInfo(param).then(res => {
                if (res.code == 200) {
                    this.info = res.result.seller
                    var list = []
                    list = res.result.good
                    if (this.pages.page == 1) {
                        // 调微信分享参数
                        this.goodsList = []
                        this.getShareData()
                    }
                    for (var i in list) {
                        this.goodsList.push(list[i])
                    }
                    if (!list || list.length < this.pages.size ) {
                        this.finished_goods = true
                    }
                } else {
                    this.finished_goods = true
                    this.$toast(res.message)
                }
                this.pages.page++
                this.loading_goods = false
                this.isLoading = false
            })
        },
        toGoodsDetail(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?goodsId=" + goods.good_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/detail',
                    query: {
                        goodsId: goods.good_id
                    }
                })
            }
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.auth_company ? that.info.auth_company : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.thumb ? (that.$publicData.withHttpStart(that.info.thumb) ? that.info.thumb : that.imageUrl+that.info.thumb)  : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
